/* eslint-disable @typescript-eslint/naming-convention */
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';


import { AuthProvider } from '../services/auth.provider';
import { Favorite } from '../models/favorite.model';
import { ConfigService } from './config.service';
import { StorageProvider } from '../services/storage.provider';
import { Observable, EMPTY } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class FavoriteService {
  readonly ADD_ACTION = 'add';
  readonly REMOVE_ACTION = 'remove';

  constructor(
    private http: HttpClient,
    private authService: AuthProvider,
    private config: ConfigService,
    private storage: StorageProvider
  ) {}

  get addToFavorites() {
    return this.changeFavorite(this.ADD_ACTION);
  }

  get removeFromFavorites() {
    return this.changeFavorite(this.REMOVE_ACTION);
  }

  getFavorites({ start = 0, limit = 10 }): Observable<Favorite[]> {
    if (this.authService.isAuthenticated() === false) {
      return EMPTY;
    }

    return this.http
      .get<Favorite[]>(`${this.config.getApiDomainByEnv()}/favorites`, {
        params: {
          start: start.toString(),
          limit: limit.toString(),
          access_token: this.storage.getStorage('access_token'),
          profil: this.storage.getStorage('logged_profile_id')
        }
      })
      .pipe(map(results => results.map(result => Favorite.fromObject(result))));
  }

  updateFavorite(type: string, id: number, add = false) {
    if (add) {
      return this.addToFavorites(type, id);
    }
    return this.removeFromFavorites(type, id);
  }

  private changeFavorite(action: string) {
    return (type: string, id: number) => {
      if (this.authService.isAuthenticated() === false) {
        return EMPTY;
      }

      const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
      let params = new HttpParams();
      params = params.set('type', type);
      params = params.set('type_id', id.toString());
      params = params.set('action', action);
      params = params.set('access_token', this.storage.getStorage('access_token'));
      params = params.set('profil', this.storage.getStorage('logged_profile_id'));

      return this.http.post(`${this.config.getApiDomainByEnv()}/favorite_change`, params, { headers });
    };
  }
}
